module.exports = __webpack_public_path__ + "static/img/pic_dkjj_uavcpjz_title.c83ba7e3.png";